import axios from 'axios'

export default class SessionService {
  /**
   * Tell the server the user is still here. The work happens in the API's
   * EnforceIdleTimeout middleware, which stamps the activity clock on the way
   * in; this only has to be a request that counts as activity.
   */
  public heartbeat() {
    return axios.post('/api/v1/session/heartbeat')
  }

  /**
   * Read the countdown without resetting it. The API excludes this route from
   * the activity stamp, so polling it after the laptop wakes reports the truth
   * rather than silently renewing the session being asked about.
   */
  public status() {
    return axios.get('/api/v1/session/status')
  }
}
